/* Real nested sidebar data parsed verbatim from the reference (reference site data/Dekstop/sidebar html.txt), trimmed to <=3 leagues x <=3 matches per sport. Keyed by sport label; sports absent here render as a
   plain (childless) nav item. Structured so a live API can replace it. */
export const SIDEBAR_TREE = {
  "Cricket": [
    {
      "league": "The Hundred - Womens",
      "matches": [
        "Manchester Super Giants W v Trent Rockets W",
        "Birmingham Phoenix W v Welsh Fire W",
        "London Spirit W v Southern Brave W"
      ]
    },
    {
      "league": "The Hundred",
      "matches": [
        "Manchester Super Giants v Trent Rockets",
        "Birmingham Phoenix v Welsh Fire",
        "London Spirit v Southern Brave"
      ]
    },
    {
      "league": "Others",
      "matches": [
        "Netherlands v Namibia",
        "Kenya v Bahrain",
        "🏏GUJARAT TITANS SO V DELHI CAPITALS SO"
      ]
    }
  ],
  "Football": [
    {
      "league": "Chinese Super League",
      "matches": [
        "Henan Songshan Longmen v Dalian Yingbo"
      ]
    },
    {
      "league": "Australia / U23 Queensland Premier League 1",
      "matches": [
        "Broadbeach United vs. Logan Lightning"
      ]
    },
    {
      "league": "Australia / Northern Territory Premier League, Reserves",
      "matches": [
        "Casuarina FC Reserves vs. Hellenic AC Reserves"
      ]
    }
  ],
  "Tennis": [
    {
      "league": "ATP Washington D.C. 2026",
      "matches": [
        "Alex de Minaur v Nakashima",
        "Fritz v Al Michelsen",
        "Jodar v Musetti"
      ]
    },
    {
      "league": "ATP Los Cabos 2026",
      "matches": [
        "Co Wong v Ar Gea",
        "Norrie v Shapovalov"
      ]
    },
    {
      "league": "WTA Washington 2026",
      "matches": [
        "J Pegula v A Kalinskaya",
        "El Cocciaretto v N Osaka",
        "Di Shnaider v L Samsonova"
      ]
    }
  ],
  "Other": [
    {
      "league": "Others",
      "matches": [
        "Vlasto Cepo V Gilbert Urbina",
        "Dusko Todorovic V Robert Valentin",
        "Aleksandr Rakic V Marcin Tybura"
      ]
    }
  ],
  "Binary": [
    {
      "league": "Others",
      "matches": [
        "Binary / 2026/07/31"
      ]
    }
  ],
  "Basketball": [
    {
      "league": "International / Club Friendly Games",
      "matches": [
        "National Chengchi University vs. Maba Sel. Team"
      ]
    },
    {
      "league": "Australia / NBL1 West, Women",
      "matches": [
        "Mandurah Magic vs. Joondalup Wolves",
        "Rockingham Flames vs. East Perth Eagles"
      ]
    },
    {
      "league": "Philippines / PBA, Governors Cup",
      "matches": [
        "Bolts vs. Barangay Ginebra",
        "Converge Fiberxers vs. Road Warriors"
      ]
    }
  ],
  "Baseball": [
    {
      "league": "Japan / NPB",
      "matches": [
        "Tokyo Yakult Swallows vs. Hanshin Tigers",
        "Saitama Seibu Lions vs. Orix Buffaloes"
      ]
    },
    {
      "league": "KBO League",
      "matches": [
        "NC Dinos vs. Kia Tigers",
        "Doosan Bears vs. LG Twins",
        "Lotte Giants vs. Samsung Lions"
      ]
    },
    {
      "league": "Chinese Taipei / CPBL",
      "matches": [
        "Fubon Guardians vs. TSG Hawks",
        "Wei Chuan Dragons vs. CTBC Brothers",
        "Uni Lions vs. Rakuten Monkeys"
      ]
    }
  ],
  "Table Tennis": [
    {
      "league": "International / TT Cup",
      "matches": [
        "Benes, Radek vs. Konvicka, Vojtech",
        "Sturma, Patrik vs. Zajac, Radek",
        "Jancak, Richard vs. Zajac, Radek"
      ]
    },
    {
      "league": "Czech Liga Pro",
      "matches": [
        "Kolek, Matyas vs. Rybar, Vaclav",
        "Huk, Martin vs. Ruzicka, Jiri",
        "Simecek, Jakub vs. Walek, Adrian"
      ]
    },
    {
      "league": "International / TT Elite Series",
      "matches": [
        "Abbasi, Amirreza vs. Strowski, Karol",
        "Solilo, Dominik vs. Wisniewski, Karol",
        "Lach, Marcin vs. Kostepski, Robert"
      ]
    }
  ],
  "Volleyball": [
    {
      "league": "Pro League",
      "matches": [
        "Titans vs. Payp",
        "Alliance vs. Tornado",
        "Lions-Pro vs. Legion-Pro"
      ]
    },
    {
      "league": "International / Club Friendly Games, Womens",
      "matches": [
        "Supreme Chonburi VC vs. Earth Power"
      ]
    },
    {
      "league": "International / Nations League",
      "matches": [
        "Slovenia vs. Poland"
      ]
    }
  ],
  "Ice Hockey": [
    {
      "league": "International / U20 Friendly Games",
      "matches": [
        "Sweden vs. Finland",
        "USA vs. Canada"
      ]
    },
    {
      "league": "International / Club Friendly Games",
      "matches": [
        "HK Lida vs. HC Kaluga"
      ]
    }
  ],
  "Rugby": [
    {
      "league": "Rugby Union / Currie Cup",
      "matches": [
        "Griquas vs. Cheetahs"
      ]
    },
    {
      "league": "Rugby League / Super League",
      "matches": [
        "Leigh Leopards vs. Wigan Warriors",
        "Leeds Rhinos vs. Toulouse Olympique XIII",
        "Hull Kingston Rovers vs. Bradford Bulls"
      ]
    },
    {
      "league": "Rugby League / NRL, Women",
      "matches": [
        "Cronulla-Sutherland Sharks vs. Wests Tigers",
        "St George Illawarra Dragons vs. Sydney Roosters"
      ]
    }
  ],
  "Mixed Martial Arts": [
    {
      "league": "PFL / PFL New York Nurmagomedov vs. Colgan",
      "matches": [
        "Delva, Chamy vs. Khabalaev, Levan",
        "de la Rosa, Montana vs. Postarnakova, Tatiana",
        "Piersma, Jonathan Hauk vs. El Dafrawy, Omar"
      ]
    }
  ],
  "Darts": [
    {
      "league": "International / Modus Super Series",
      "matches": [
        "Campbell, Scott vs. Burnett, Richie",
        "Brown, Keegan vs. Howson, Richie",
        "West, Steve vs. Thornton, Robert"
      ]
    }
  ],
  "Futsal": [
    {
      "league": "Argentina / Primera Division",
      "matches": [
        "Independiente vs. River Plate"
      ]
    }
  ]
};
